'use client'

import {
  NotificationContextProvider,
  PusherProvider,
  QueryContextProvider,
  SdkProvider,
  SessionProvider,
  SubscribeNotificationProvider,
  UpFetchProvider,
} from '@repo/sdk'
import { Session } from '@repo/sdk/auth'
import { SidebarProvider, UIProvider } from '@repo/ui'
import { ReactNode } from 'react'

import { useSubscribeNotification } from '@/hooks/use-subscribe-notification.tsx'

export const Provider = ({ children }: { children: ReactNode }) => {
  return (
    <SdkProvider>
      <UIProvider>{children}</UIProvider>
    </SdkProvider>
  )
}

export const AuthorizedProvider = ({
  children,
  session,
}: {
  children: ReactNode
  session: null | Session
}) => {
  const { subscribeFn } = useSubscribeNotification()

  return (
    <SessionProvider session={session}>
      <UpFetchProvider accessToken={session?.user?.access_token}>
        <PusherProvider accessToken={session?.user?.access_token}>
          <NotificationContextProvider>
            <QueryContextProvider>
              <SubscribeNotificationProvider subscribeFn={subscribeFn}>
                <SidebarProvider defaultOpen={true}>{children}</SidebarProvider>
              </SubscribeNotificationProvider>
            </QueryContextProvider>
          </NotificationContextProvider>
        </PusherProvider>
      </UpFetchProvider>
    </SessionProvider>
  )
}
